import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type InvoiceFilterSelectProps = {
    label: string;
    menuItems: string[];
    optionSelected: string;
    onSelectFilterChange: (filterValue: string) => void;
    translationNamespace?: string;
};

const InvoiceFilterSelect: FC<InvoiceFilterSelectProps> = ({
    label,
    menuItems,
    optionSelected,
    onSelectFilterChange,
    translationNamespace,
}: InvoiceFilterSelectProps) => {
    const { t: translate } = useTranslation(['common', 'invoices', 'orders']);

    const optionsHandler = (event: SelectChangeEvent<string>) => {
        onSelectFilterChange(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <InputLabel>{translate(label)}</InputLabel>
            <Select label={translate(label)} value={optionSelected} onChange={optionsHandler}>
                {menuItems.map((item: string, index) => (
                    <MenuItem key={index} value={item}>
                        {translate(`${translationNamespace ? translationNamespace : 'invoices'}:${item}`)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default InvoiceFilterSelect;
